import request from '../request.js';
import Servers from '@config'

export default {
  fetchTencentCloudAuth: request.get(Servers.oss + '/agency/upload/auth'),
}
